import React, { Component } from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import CrewContainer from '../../layouts-components__common-cases/crew-container';

import './style.sass';

const team = {
    crewList: [
        {
            crewItemImg: '',
            crewItemTitle: 'Виктория Вишненко',
            crewItemSubtitle: 'Менеджер проекта',
        },
        {
            crewItemImg: '',
            crewItemTitle: 'Сергей Бурлуцкий',
            crewItemSubtitle: 'Тимлид SEO-отдела',
        },
        {
            crewItemImg: '',
            crewItemTitle: '2 SEO-специалиста',
            crewItemSubtitle: '',
        },
    ],
};

class Team extends Component {
    render() {
        return (
            <div className="otpBank-team">
                <FullWrapper>
                    <div className="otpBank-team__Title">Команда</div>
                    <CrewContainer container={team} />
                </FullWrapper>
            </div>
        );
    }
}

export default Team;
